import { Component, OnInit, Input, Output, ViewEncapsulation, EventEmitter } from '@angular/core';

@Component({
    selector: 'topo-confirm-delete',
    templateUrl: './confirm-delete.component.html',
    styleUrls: ['./confirm-delete.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ConfirmDeleteComponent implements OnInit {
  @Input() isActive: boolean;
  @Input() itemNames: string[];

  @Output() confirmResponse = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  onClose(): void {
    this.confirmResponse.emit(false);
  }

  cancelClick(): void {
    this.confirmResponse.emit(false);
  }

  deleteClick(): void {
    this.confirmResponse.emit(true);
  }
}
